export default __webpack_public_path__ + "static/media/datascience.f0031a6a.png";